export const LimitPageVariants = [
  {value: 3, name: '3'},
  {value: 50, name: '50'},
  {value: 100, name: '100'},
  {value: 250, name: '250'},
]

export const LimitPageDefault = {
  value: 50, name: '50'
}